export const UPDATE_EXTENSION = "UPDATE_EXTENSION";

export const TOGGLE_ZSTACK_SCREENSHOT = "TOGGLE_ZSTACK_SCREENSHOT";

export const UPDATE_BARCODE_IMG_ROTATION = "UPDATE_BARCODE_IMG_ROTATION";